export const MAX_EMAIL_LENGTH = 256;
// RFC違反のメールアドレス(example..@example.comなど)も受け入れる
// regex originates from graffer-schemas: https://github.com/graffer-inc/graffer-schemas/blob/v11.0.2/libs/packages/form-schema/lib/elements-schema/input-schema/email-input-element/email-input-element.ts#L28
const emailRegex = /.+@[*[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+]*$/;

export const verifyEmail = (email: string) => {
  return !validateEmail(email);
};

export const validateEmail = (email: string) => {
  if (!email || email === "") {
    return "メールアドレスを入力してください";
  }
  if (email.length > MAX_EMAIL_LENGTH) {
    return `メールアドレスは${MAX_EMAIL_LENGTH}文字以内で入力してください`;
  }
  return !emailRegex.test(email)
    ? "メールアドレスの形式が正しくありません"
    : undefined;
};
